export default __webpack_public_path__ + "static/media/Poderes of Effulgent Devotion.c3cd8859.jpg";